<template>
  <div></div>
</template>
<script>
export default {
  created() {
    let back_url = this.getQueryString('back_url');
    let token = localStorage.getItem('ms_token')
    if(token){
        window.location.href = back_url+"?token="+token
    }else{
        this.$router.push({
            path:'/login',
            query:{
                back_url:back_url
            }
        })
    }
  },
  methods: {
      
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
  },
};
</script>